import toast from "@markaaz/ui/MzToast";
import * as api from "api/endpoints/monitoring";
import { createSlice, createSliceSelector } from "../factory";

const name = "monitoringPage";

const initialState = {
  business: {}
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectBusiness = createSelector((state) => {
  return state.business;
});

/* Actions */
const { update } = slice.actions;

export function loadMonitoringBusiness(portfolioId) {
  return async function (dispatch) {
    api.getBusinessById(portfolioId).then((res) => {
      const payload = { business: res.details };
      dispatch(update(payload));
    });
  };
}

export function submitMonitoringBusiness(portfolioId) {
  return async function (dispatch, getState) {
    const business = selectBusiness(getState());

    const reqBody = {
      ...business,
      approvalStatus: undefined,
      approvedOn: undefined,
      businessReportFrequency: undefined
    };
    api
      .postBusiness(reqBody)
      .then(() => {
        dispatch(loadMonitoringBusiness(portfolioId));
        toast.show("Successully Updated");
      })
      .catch(() => {
        toast.show("Something went wrong. Please try after some time.", { severity: "error" });
      });
  };
}

export function updateMonitoringBusiness(changedValue) {
  return async function (dispatch, getState) {
    const data = selectBusiness(getState());

    const newValues = Object.assign({}, data, changedValue);
    const payload = {
      business: newValues
    };

    dispatch(update(payload));
  };
}
